<template>
  <div class="login-page__content pt-2 pb-12 min-h-screen bg-ma-gray-11">
    <div class="logo-wrapper my-6">
      <img src="/assets/images/shared/logo.png" class="logo-image mx-auto" />
    </div>
    <div class="gr px-0">
      <div class="login-box sm:bg-ma-0 bg-white mx-auto">
        <form
          @submit.prevent="
            createFromTeamInviteToken({
              firstname: inviteMember.firstname,
              lastname: inviteMember.lastname,
              password: inviteMember.password,
              terms: inviteMember.terms,
            })
          "
          class="login-form py-8 px-6 text-ma-black-1 m-auto"
        >
          <ul>
            <li class="text-center">
              <p class="text-xl leading-6 mx-auto mb-2 font-semibold">
                Welcome!
              </p>
              <p class="text-ma-gray-3 mb-8 text-base  font-regular sub-title">
                You have been invited to join a team. Please
                complete your team account signup.
              </p>
            </li>

            <Message v-if="errorMessage1" :message="errorMessage1" level="error" class="mb-5"/>

            <li
              class="text-center sm:flex sm:items-stretch sm:text-sm sm:mt-4 sm:mb-3"
            >
              <div
                class="mt-3 mb-3 sm:text-left sm:my-0 text-sm sm:w-1/2 relative"
              >
                <label
                  for="first-name"
                  class="uppercase text-left sm:text-ma-black-1 font-bold block mb-1"
                  >First name</label
                >
                <input
                  id="first-name"
                  type="text"
                  v-model="inviteMember.firstname"
                  name="first-name"
                  :disabled="inviteLoading.inviteMember"
                  class="w-full p-2 ma-black-1"
                />
                <div
                  v-if="hasError1('firstname')"
                  class="text-ma-red-1 text-base mb-1 text-left"
                >
                  {{ hasError1("firstname") }}
                </div>
              </div>
              <div
                class="mt-3 mb-3 sm:text-left sm:ml-4 sm:my-0 text-sm sm:w-1/2 relative"
              >
                <label
                  for="last-name"
                  class="uppercase text-left sm:text-ma-black-1 font-bold block mb-1"
                  >Last name</label
                >
                <input
                  id="last-name"
                  type="text"
                  v-model="inviteMember.lastname"
                  name="last-name"
                  :disabled="inviteLoading.inviteMember"
                  class="w-full p-2 ma-black-1"
                />
                <div
                  v-if="hasError1('lastname')"
                  class="text-ma-red-1 text-base mb-1 text-left"
                >
                  {{ hasError1("lastname") }}
                </div>
              </div>
            </li>

            <li class="text-left mb-3 relative">
              <label
                for="choose-password"
                class="uppercase sm:text-ma-black-1 font-bold block mb-1"
                >Choose Password</label
              >
              <input
                id="choose-password"
                type="password"
                v-model="inviteMember.password"
                :disabled="inviteLoading.inviteMember"
                name="choosePassword"
                class="w-full p-2 ma-black-1"
              />
              <div
                v-if="hasError1('password')"
                class="text-ma-red-1 text-base mb-3"
              >
                {{ hasError1("password") }}
              </div>
            </li>

            <li class="text-left">
              <label
                class="font-semibold ma-checkbox"
                :class="{
                  'ma-checkbox--checked': inviteMember.terms,
                  'mb-1': hasError1('terms'),
                  'mb-6': !hasError1('terms'),
                }"
              >
                <input
                  type="checkbox"
                  v-model="inviteMember.terms"
                  name="agree"
                  :disabled="inviteLoading.inviteMember"
                />
                <span
                  class="ma-checkbox__toggle"
                  v-bind:style="{
                    backgroundColor: inviteMember.terms
                      ? '#66c7d8'
                      : 'transparent',
                  }"
                ></span>
                <div class="ma-checkbox__label uppercase">
                  I AGREE TO THE MOTION ARRAY
                  <a href="/terms-of-service" class="underline italic"
                    >TERMS OF SERVICE</a
                  >
                  AND
                  <a href="/privacy-policy" class="underline italic"
                    >PRIVACY POLICY.</a
                  >
                </div>
              </label>
              <div
                v-if="hasError1('terms')"
                class="text-ma-red-1 text-base mb-6"
              >
                {{ hasError1("terms") }}
              </div>
            </li>

            <li class="text-center">
              <button
                type="submit"
                :disabled="inviteLoading.inviteMember"
                class="font-semibold block bg-ma-blue-1 w-48 mx-auto p-2 text-white"
                :class="
                  inviteLoading.inviteMember
                    ? 'opacity-50'
                    : 'hover:bg-ma-blue-0'
                "
              >
                Join Team
              </button>
            </li>
          </ul>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Message from "@/components/Message";

export default {
  components: {
    Message,
  },
  computed: {
    ...mapGetters({
      invitedByUser: "teamInvitation/invitedByUser",
      inviteMember: "teamInvitation/inviteMember",
      errorMessage1: "teamInvitation/errorMessage1",
      hasError1: "teamInvitation/hasError1",
      inviteLoading: "teamInvitation/inviteLoading",
    }),
  },
  mounted() {
    this.setInviteToken({
      token: this.$route.params.token
    });
  },
  methods: {
    ...mapActions({
      createFromTeamInviteToken: "teamInvitation/createFromTeamInviteToken",
      setInviteToken: "teamInvitation/setInviteToken",
    }),
  },
  metaInfo: () => ({
    bodyAttrs: { class: "login-page" },
    title: "New Member | Motion Array",
    link: [{ rel: "stylesheet", href: "/assets/site/css/team-invite.css" }],
  }),
};
</script>

<style scoped>
.login-page {
  .login-page__content {
    @screen sm {
      overflow: hidden;
    }
  }

  .logo-wrapper {
    .logo-image {
      width: 149px;
      height: 29px;
    }
  }

  .content {
    position: relative;
    background-color: #000;
    padding-top: 0;

    form {
      label {
        font-size: 13px;
      }

      @media (max-width: theme("screens.sm")) {
        .keep-me-logged {
          margin-bottom: 150px;
        }
      }
    }
  }

  .login-box >>> .login-form {
    input {
      height: 44px;
    }
    label {
      font-size: 13px;
    }
    .sub-title {
      font-weight: 500;
      align-items: center;
    }
    .ma-checkbox {
      @apply cursor-pointer;
      .wrap {
        align-items: center;
      }

      .ma-checkbox__toggle {
        width: 20px;
        height: 20px;
        font-size: 9px;
        @apply border-2 border-ma-gray-3 bg-transparent text-transparent;
      }

      @screen sm {
        &:hover {
          .ma-checkbox__toggle {
            @apply text-ma-gray-3;
          }
        }
      }

      &.ma-checkbox--checked {
        .ma-checkbox__toggle {
          @apply border-0 bg-ma-green-1 text-white;
        }
      }
    }
  }

  @screen sm {
    .login-box {
      max-width: 900px;

      form {
        max-width: 730px;
      }
    }
  }
}
</style>
